import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import OfferPartnerQuestionsListItemComponent from './OfferPartnerQuestionListItemComponent';
import { Grid } from '@mui/material';
import { Button, Card } from '@totalsoft/rocket-ui';
import CancelRounded from '@mui/icons-material/CancelRounded';
import CheckCircle from '@mui/icons-material/CheckCircle';

const OfferPartnerEditQuestionsListComponent = ({
  partnerQuestions,
  questionnaire,
  editQuestionnaireMode,
  onStartQuestionnaireSpecificQuestion,
  onDoneQuestionnaire,
  onCancelQuestionnaire,
  isFinished,
  currentQuestionIsEmpty,
  t
}) => {
  return (
    <>
      <Card
        title={
          questionnaire.questionnaireScore
            ? t('OfferEdit.Client.Questionnaire.DocumentPartnerQuestion.AnsweredQuestions') +
              ' (' +
              t('OfferEdit.Client.Questionnaire.DocumentPartnerQuestion.QuestionScore') +
              questionnaire.questionnaireScore +
              ')'
            : t('OfferEdit.Client.Questionnaire.DocumentPartnerQuestion.AnsweredQuestions')
        }
      >
        <Grid container gap={2}>
          {partnerQuestions.map((item, idx) => {
            return (
              <Grid item xs={12} key={idx}>
                <OfferPartnerQuestionsListItemComponent
                  currentQuestion={item}
                  editQuestionnaireMode={editQuestionnaireMode}
                  questionnaire={questionnaire}
                  onStartQuestionnaireSpecificQuestion={onStartQuestionnaireSpecificQuestion}
                />
              </Grid>
            );
          })}
          {currentQuestionIsEmpty && !isFinished && (
            <Grid item xs={12} align='right'>
              <Button id={'offerPartnerQuestionnaire_cancelBtn'} color='error' onClick={onCancelQuestionnaire}>
                <CancelRounded /> {t('Cancel')}
              </Button>
            </Grid>
          )}
          {isFinished && (
            <Grid item xs={12} align='right'>
              <Button id={'offerPartnerQuestionnaire_doneBtn'} color='success' onClick={onDoneQuestionnaire}>
                <CheckCircle /> {t('OfferEdit.Client.Questionnaire.DocumentPartnerQuestion.SaveQuestionnaire')}
              </Button>
            </Grid>
          )}
        </Grid>
      </Card>
    </>
  );
};
OfferPartnerEditQuestionsListComponent.propTypes = {
  partnerQuestions: PropTypes.array.isRequired,
  questionnaire: PropTypes.object,
  editQuestionnaireMode: PropTypes.bool.isRequired,
  onStartQuestionnaireSpecificQuestion: PropTypes.func.isRequired,
  onDoneQuestionnaire: PropTypes.func.isRequired,
  onCancelQuestionnaire: PropTypes.func.isRequired,
  isFinished: PropTypes.bool.isRequired,
  currentQuestionIsEmpty: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired
};

export default compose(withTranslation())(OfferPartnerEditQuestionsListComponent);
